module.exports = __webpack_public_path__ + "static/img/dd-banner-01.0810495.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-banner-01.png
// module id = FWHB
// module chunks = 1